import styled from "styled-components";
import stylesForm from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import selectStyles from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";

// Styled Components

const TitleWrapperStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const TitleStyled = styled.h4`
  color: #3c4858;
`;

// Styles Mui
const styles = (theme) => ({
  ...stylesForm,
  ...selectStyles,
  buttonIcon: {
    margin: "0 !Important",
    width: "18px",
  },
  selectLabel: {
    ...selectStyles.selectLabel,
    color: "#AAAAAA",
    fontSize: "14px",
    marginTop: ".5rem",
    textTransform: "capitalize",
  },
});

export { TitleWrapperStyled, TitleStyled, styles };
